import { styled } from '@nykaa/ui-components';
import { COLORS, BASE_GUTTER_SPACE } from 'shared/styles/base';
import { keyframes } from '@emotion/core';

const progress = keyframes`{
    0% {
        opacity: 0;
        bottom: -32px;
    }
    10% {
        opacity: 100%;
        bottom: 0px;
    }
    90% {
        opacity: 100%;
        bottom: 0px;
    }

    100% {
        opacity: 0;
        bottom: -32px;

    }
}`;

export const MessageContainer = styled.div`
  width: 100%;
  height: 32px;
  background-color: ${COLORS.BLACK_92};
  position: absolute;
  bottom: 0px;
  z-index: 3;
  display: flex;
  opacity: 0;
  align-items: center;
  animation: ${progress} 2.6s linear;
`;

export const Text = styled.p`
  ${({ theme }) => theme.typography.bodyMedium};
  padding: 0 0 0 ${BASE_GUTTER_SPACE}px;
  color: #fff;
  opacity: 0.92;
`;
